export enum LandingStatus {
  NotCompleted = 'jbp-plan-notcompleted',
  Completed = 'jbp-plan-completed',
  PendingAcknowledgment = 'jbp-plan-pending-acknowledgment',
  Acknowledged = 'jbp-plan-acknowledged',
  NotApplicable = 'jbp-plan-not-applicable',
  PendingReview = 'jbp-plan-pending-review',
  Reviewed = 'jbp-plan-reviewed',
}
